import { defineStore } from 'pinia';

import { Product } from '@/types/api/Model/Product';

export const useProductStore = defineStore('productStore', {
  state: () => ({
    productTypes: [] as Product[],
  }),
  actions: {
    setProductTypes(productTypes: Product[]) {
      this.productTypes = productTypes;
    },
  },
});
